import { useEffect, useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Select,
    FormControl,
    FormLabel,
    FormHelperText,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
} from "@chakra-ui/react";
import { LINK_TYPES } from "../../constants/linkTypes";

const EMPTY_FORM = { name: "", url: "", type: 0, order: 0 };

const EditModal = ({ isOpen, onClose, onSave, editData: initialData }) => {
    const [formData, setFormData] = useState(initialData || EMPTY_FORM);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setFormData(initialData || EMPTY_FORM);
        }
    }, [isOpen, initialData]);

    if (!formData) return null;

    const isCustom = Number(formData.type) === 0;

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await onSave(formData);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{formData?.id ? "Uredi poveznicu" : "Dodaj poveznicu"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl mb={3}>
                        <FormLabel>Naziv</FormLabel>
                        <Input
                            placeholder="npr. Website"
                            value={formData?.name || ""}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                    </FormControl>

                    <FormControl mb={3}>
                        <FormLabel>Tip</FormLabel>
                        <Select
                            value={formData?.type ?? 0}
                            onChange={(e) => setFormData({ ...formData, type: Number(e.target.value) })}
                        >
                            {LINK_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>{type.label}</option>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl mb={3}>
                        <FormLabel>URL</FormLabel>
                        <Input
                            placeholder="https://..."
                            value={formData?.url || ""}
                            onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                        />
                        {!isCustom && (
                            <FormHelperText>
                                Za ovaj tip URL se trenutno generira ručno - automatsko generiranje iz metapodataka dolazi kasnije.
                            </FormHelperText>
                        )}
                    </FormControl>

                    <FormControl>
                        <FormLabel>Redoslijed</FormLabel>
                        <NumberInput
                            min={0}
                            value={formData?.order ?? 0}
                            onChange={(_, valueAsNumber) =>
                                setFormData({ ...formData, order: Number.isNaN(valueAsNumber) ? 0 : valueAsNumber })
                            }
                        >
                            <NumberInputField />
                            <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                            </NumberInputStepper>
                        </NumberInput>
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button
                        bg="brand.600"
                        color="white"
                        _hover={{ bg: "brand.700" }}
                        mr={3}
                        onClick={handleSave}
                        isLoading={isSaving}
                        loadingText="Spremanje..."
                        isDisabled={isSaving}
                    >
                        Spremi
                    </Button>
                    <Button onClick={onClose} isDisabled={isSaving}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditModal;
